export enum MqttMsgType{
    CHAT = 'MSG',
    STATUS_UPDATE = 'STATUS_UPDATE'
}